export const TRANSLATIONS_FR_SETTINGS_CORE = {
  "settings.tab_google_integrations": "Intégrations Google",
  "settings.db_connection_title": "Connexion à la base de données",
  "settings.db_tables_title": "Tables de la base de données",
  "settings.db_table_name": "Nom de la table",
  "settings.db_send_selected": "Envoyer les tables sélectionnées",
  "settings.db_loading": "Traitement de la connexion...",
  "settings.db_connect_success": "Connexion à la base de données réussie.",
  "settings.db_connect_error": "Erreur de connexion à la base de données.",
  "settings.db_not_configured": "Les identifiants de connexion a la base n'ont jamais ete configures.",
  "settings.db_send_success": "Tables envoyées avec succès.",
  "settings.db_send_error": "Erreur lors de l'envoi des tables.",
  "settings.db_tables_error": "Erreur lors de la récupération des tables.",
  "settings.db_table_connect_success": "Table connectée avec succès.",
  "settings.db_table_connect_error": "Erreur lors de la connexion à la table.",
  "settings.cancel": "Annuler",
  "settings.theme": "Thème",
  "settings.language": "Langue",
  "settings.light": "Clair",
  "settings.dark": "Sombre",
  "settings.spanish": "Espagnol",
  "settings.english": "Anglais",
  "settings.portuguese": "Portugais",
  "settings.french": "Français",
  "settings.japanese": "Japonais",
  "settings.title": "Paramètres",
  "settings.customization": "Personnalisation",
  "settings.company_logo": "Logo de l'entreprise",
  "settings.logo_placeholder": "Téléversez votre logo ici",
  "settings.save": "Enregistrer",
  "settings.save_error": "Erreur lors de l'enregistrement des paramètres",
  "settings.db_type": "Type de base de données",
  "settings.db_host": "Hôte",
  "settings.db_port": "Port",
  "settings.db_user": "Utilisateur",
  "settings.db_password": "Mot de passe",
  "settings.db_name": "Base de données",
  "settings.select_db_type": "Sélectionner...",
  "settings.tab_preferences": "Préférences",
  "settings.tab_bc_email_pooling": "BC Email Pooling",
  "settings.bc_title": "E-mail BC lié",
  "settings.bc_create_btn": "Ajouter un e-mail BC",
  "settings.bc_update_btn": "Mettre à jour l'e-mail BC",
  "settings.bc_create_success": "E-mail BC lié avec succès.",
  "settings.bc_create_error": "Erreur lors de la liaison de l'e-mail BC.",
  "settings.bc_update_success": "E-mail BC mis à jour avec succès.",
  "settings.bc_update_error": "Erreur lors de la mise à jour de l'e-mail BC.",
  "settings.bc_not_configured": "Aucun BC User Binding n'est configure pour cet utilisateur.",
  "settings.whatsapp_not_configured": "Aucun numero WhatsApp n'a ete configure.",
  "settings.tab_email_oauth": "Permission e-mail (OAuth)",
  "settings.email_oauth_title": "Permission de connexion e-mail (OAuth)",
  "settings.email_oauth_placeholder":
    "Vous pourrez bientôt autoriser l'accès à votre fournisseur d'e-mail (Gmail, Outlook, etc.).",
  "settings.penalty_questions.tfidf_min": "TF-IDF minimum",
  "settings.penalty_questions.embedding_min": "Embedding minimum",
  "settings.penalty_questions.tfidf_penalty": "Pénalité TF-IDF",
  "settings.penalty_questions.save":
    "Enregistrer la configuration de la pénalité",
  "settings.penalty_questions.load_error":
    "Erreur lors du chargement de la configuration de la pénalité.",
  "settings.penalty_questions.save_success":
    "Configuration de la pénalité enregistrée avec succès.",
  "settings.penalty_questions.save_error":
    "Erreur lors de l'enregistrement de la configuration de la pénalité.",
  "settings.penalty_questions.enabled": "Activer la pénalité des questions",
  "settings.tab_advanced": "Avancé",
  "settings.advanced.title": "Paramètres avancés",
  "settings.penalty_questions": "Pénalité des questions",
  "settings.penalty_questions.header_parameter":
    "Paramètres de pénalité des questions",
  "settings.penalty_questions.header_value": "Valeur",
  "settings.error_required": "Ce champ est obligatoire.",
  "settings.advanced_title": "Paramètres avancés",
  "settings.all_types": "Tous les types",
  "settings.select": "Sélectionner",
  "settings.edit": "Modifier",
  "settings.delete": "Supprimer",
  "settings.tables": "Tables",
  "settings.search_table": "Rechercher une table",
  "settings.no_tables": "Aucune table disponible",
  "settings.database": "Base de données",
  "settings.host": "Hôte",
  "settings.port": "Port",
  "settings.username": "Nom d'utilisateur",
  "settings.password": "Mot de passe",
  "settings.logo_help": "Téléversez un logo au format PNG ou SVG",
  "settings.logo_error": "Erreur lors du téléversement du logo",
  "settings.close": "Fermer",
  "settings.save_success": "Paramètres enregistrés avec succès",
  "settings.bc_email_label": "E-mail BC",
  "settings.db_delete_success": "Connexion BD supprimée avec succès",
  "settings.db_delete_error": "Erreur lors de la suppression de la connexion BD",
  "settings.select_tables": "Sélectionner des tables",
  "settings.whatsapp_title": "Paramètres WhatsApp",
  "settings.whatsapp_country_code": "Code pays",
  "settings.whatsapp_country_code_placeholder": "Saisir le code pays",
  "settings.whatsapp_country_code_error": "Saisissez un code pays valide",
  "settings.whatsapp_number": "Numéro WhatsApp",
  "settings.whatsapp_number_error": "Numéro invalide",
  "settings.whatsapp_invalid_number": "Numéro invalide",
  "settings.whatsapp_invalid_reason_format": "Format invalide",
  "settings.whatsapp_invalid_reason_possible": "Numéro impossible pour le pays sélectionné",
  "settings.whatsapp_invalid_reason_valid": "Numéro non valide",
  "settings.whatsapp_save_btn": "Enregistrer",
  "settings.whatsapp_save_success": "Numéro WhatsApp enregistré",
  "settings.whatsapp_save_error": "Erreur lors de l'enregistrement du numéro WhatsApp",
  "settings.whatsapp_update_success": "Numéro WhatsApp mis à jour",
  "settings.whatsapp_update_error": "Erreur lors de la mise à jour du numéro WhatsApp",
  "settings.whatsapp_delete_btn": "Supprimer",
  "settings.whatsapp_delete_success": "Numéro WhatsApp supprimé",
  "settings.whatsapp_delete_error": "Erreur lors de la suppression du numéro WhatsApp",
  "settings.whatsapp_edit_btn": "Modifier",
  "settings.whatsapp_configured_number": "Numéro configuré :",
  "settings.tab_microsoft_integrations": "Integrations Microsoft",
  "settings.reindex.title": "Réindexer les documents",
  "settings.reindex.description": "Retraite tous vos documents dans Home IA et Knowledge Hub (reclassification et extraction de connaissances). À utiliser si vous avez modifié vos règles ou souhaitez actualiser l'analyse. Ne renvoie pas les fichiers.",
  "settings.reindex.button": "Réindexer mes documents",
  "settings.reindex.confirm": "Oui, réindexer",
  "settings.reindex.cancel": "Annuler",
  "settings.reindex.error": "Impossible de démarrer la réindexation. Veuillez réessayer.",
  "settings.purge.title": "Supprimer tous mes documents",
  "settings.purge.description": "Supprime définitivement tous vos documents (fichiers inclus), conversations, classifications et données Home IA / Knowledge Hub. Cela déconnecte également vos comptes Google et Microsoft (en supprimant leurs jetons et données de synchronisation) ; vous devrez donc les reconnecter pour synchroniser à nouveau. L'historique d'utilisation des tokens est conservé. Le nettoyage s'exécute en arrière-plan et vous recevrez une notification à la fin.",
  "settings.purge.button": "Supprimer tous mes documents",
  "settings.purge.confirm": "Oui, tout supprimer",
  "settings.purge.cancel": "Annuler",
  "settings.purge.error": "Impossible de démarrer le nettoyage. Veuillez réessayer.",
};
